import React, { useState } from 'react';
import Headline from '../../partials/Headline';

interface IPrice {
  name: string;
  value: string;
}

interface IPricesToRowProps {
  prices: IPrice[];
}

interface IPriceListProps {
  headline?: string;
  pricesArray: IPrice[];
}

export const PricesToRow = (props: IPricesToRowProps) => {
  const { prices } = props;

  const list = prices.map((price: IPrice, index: number) => {
    const { name, value } = price;

    if ( !name || !value ) return null;

    return (
      <li className="price-line" key={index}>
        <span className="price-name">
          { name }
        </span>
        <span className="price-value">
          { value }
        </span>
      </li>
    )
  });

  return <>{list}</>;
}

const PriceList = (props: IPriceListProps) => {
  const [ open, setOpen ] = useState(false);

  const { headline, pricesArray } = props;

  return (
    <div className="price-list-wrapper">
      {headline && 
        <Headline
          h={2}
          className="price-list-headline"
          underline={false}
        >
          {headline}
        </Headline>
      }
      <ul className={`prices-list ${open ? 'open' : ''}`}>
        {
          pricesArray.length > 0 ?
            <PricesToRow prices={pricesArray} />
            : <span className="no-prices">ceník se připravuje</span>
        }
      </ul>
      {!open && 
        <div className="button-wrap">
          <button
            className="btn"
            type="button"
            onClick={() => setOpen(true)}
          >
            ukázat ceny
          </button>
        </div>
      }
    </div>
  );
}

export default PriceList;